module.exports = __webpack_public_path__ + "static/media/16.37b6953e.png";